import axios from "axios";

export const BASE_URL = "https://apiv2.shipora.io/api";
export const IMG_URL = "https://apiv2.shipora.io/api/get-images";
// export const BASE_URL = "http://localhost:3000/api";
// export const IMG_URL = "http://localhost:3000/api/get-images";

const api = axios.create({ baseURL: BASE_URL });
const addressApi = axios.create({ baseURL: BASE_URL });

const getAccessToken = () => {
  const token = localStorage.getItem("token")
  return token;
};

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.method === "get" || config.method === "delete") {
      config.params = { ...config.params };
    } else {
      config.data = { ...config.data };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

addressApi.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const loginApi = async (userData) => {
  try {
    const response = await api.post(`/content-admin/login`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Login failed";
  }
};


export const createBlogCategoryApi = async (userData) => {
  try {
    const response = await api.post(`/create-blog-category`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};




export const getBlogCategoriesApi = async (userData) => {
  try {
    const response = await api.post(`/get-blog-category/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const deleteBlogcategoryApi = async (userData) => {
  try {
    const response = await api.post(`/delete-blog-category/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


//Tags



export const createBlogTagsApi = async (userData) => {
  try {
    const response = await api.post(`/create-blog-tag`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};




export const getBlogTagsApi = async (userData) => {
  try {
    const response = await api.post(`/get-tags/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const deleteBlogTagsApi = async (userData) => {
  try {
    const response = await api.post(`/delete-tag/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



//Get All Blogs



export const getAllBlogsApi = async (userData) => {
  try {
    const response = await api.post(`/get-blogs/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


//Create Blog



export const createBlogApi = async (formData) => {
  try {
    const token = getAccessToken();

    const response = await axios.post(`${BASE_URL}/create-blog`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    // throw error.response?.data?.message || "failed!";

    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};

//Delete Blogs

export const deleteBlogsApi = async (userData) => {
  try {
    const response = await api.post(`/delete-blog/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


//Slider Management 



export const getSliderImagesApi = async () => {
  try {
    const response = await api.get(`/get-sliders/admin`);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


export const addSliderImageApi = async (userData) => {
  try {
    const response = await api.post(`/add-slider-image/admin`, userData);
    return response.data;
  } catch (error) {

    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};


export const deleteSliderImageApi = async (userData) => {
  try {
    const response = await api.post(`/delete-slider-image/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const createCaseStudyApi = async (userData) => {
  try {
    const token = getAccessToken();

    const response = await axios.post(`${BASE_URL}/create-and-update-case-study/admin`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    error.customMessage = error.response?.data?.message || "Failed";
    throw error;
  }
};


//Get All Case Studies

export const getCaseStudies = async () => {
  try {
    const response = await api.get(`/get-case-study/admin`);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};



export const deleteCaseStudies = async (userData) => {
  try {
    const response = await api.post(`/delete-case-study/admin`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


export const getDashboardDetailsApi = async (userData) => {
  try {
    const response = await api.get(`/get-cms-dashboard-details`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

//Get Contact Inquiry API


// /get-contact-inquiry

export const getContactInquiryAPi = async (userData) => {
  try {
    const response = await api.get(`/get-contact-inquiry`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};


export const changePasswordApi = async (userData) => {
  try {
    const response = await api.post(`/content-admin/change-password`, userData);
    return response.data;
  } catch (error) {

    throw error?.response?.data?.message || "Check Network Connection";
  }
};

export const createShippingCharges = async (data) => {
  try {
    const response = await api.post("/create-shipping-calculator", data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}

export const getShippingChargesRecords = async () => {
  try {
    const response = await api.get("/get-shipping-calculator");
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}


export const updateShippingCharges = async (chargeId, chargeData) => {
  try {
    const response = await api.put(`/update-shipping-calculator/${chargeId}`, chargeData);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}

export const deleteShippingCharges = async (chargeId) => {
  try {
    const response = await api.delete(`/delete-shipping-calculator/${chargeId}`);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}


export const getAllShippingEnquiryApi = async () => {
  try {
    const response = await api.get(`/get-shipping-inquiries`);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}


//Get Discount API

export const getDiscountApi = async () => {
  try {
    const response = await api.get(`/get-discount-records`);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}

//Create Discount Setup

export const createDiscountApi = async (data) => {
  try {
    const response = await api.post("/create-shipping-discount", data);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}

//Update Discount API

export const updateDiscountApi = async (discountId, discountData) => {
  try {
    const response = await api.put(`/update-shipping-discount/${discountId}`, discountData);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}

//Delete Shipping Discount

export const deleteDiscountApi = async (discountId) => {
  try {
    const response = await api.delete(`/delete-shipping-discount/${discountId}`);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";

  }
}


//Get All Support Count 

export const getSupportCountApi = async () => {
  try {
    const response = await api.get(`/support/get-new-open-support-count`);
    return response.data
  } catch (error) {
    console.log(error);
    throw error?.response?.data?.message || "Check Network Connection";
  }
}











export { api, addressApi };
